/**
 * @module Configuration
 */
//  Created by scottrohrer on 10/7/16.
define(function () {
    var instance = null;
    /**
     * @class Configuration
     */
    function Configuration() {
        this.userScaleFactor = 1.0;
        this.showVesselStats = true;
        // add other things that are currently being handled in a less efficient way
    }
    Configuration.getInstance = function() {
        if(instance === null) {
            instance = new Configuration();
        }
        return instance;
    };
    return Configuration.getInstance();
});
